import React from 'react';
import CSVImporterRemoveShopifyTag from '../CSVImporterRemoveShopifyTag';

const RemoveTag = () => {
  return (
    <div>
      <h2 className="header">remove Tag</h2>
      <div style={{ textAlign: 'center' }}>
        <CSVImporterRemoveShopifyTag />
      </div>
    </div>
  );
};

export default RemoveTag;
